import request from 'Apis/rest'
import axios from 'axios'
import { urlBase } from 'Apis/rest'
import { API } from 'aws-amplify'
import { listNotifications } from 'graphql/queries'
import { onChangeNotification } from 'graphql/subscriptions'
import { updateNotification } from 'graphql/mutations'

export const TOUCH_NOTIFICATION = 'TOUCH_NOTIFICATION'
export const FETCH_NOTIFICATION_COUNT = 'FETCH_NOTIFICATION_COUNT'
export const CLEAR_NOTIFICATIONS = 'server/clearNotification'
export const HIDE_NEW_NOTIFICATION = 'hideNewNotification'
export const NOTIFICATION_COUNT = 'notificationCount'

//var array_payload = [];

export const touchNotification = (msgId) => (dispatch, getState) => {
  let email = getState().login.email
  dispatch({
    type: TOUCH_NOTIFICATION,
    payload: {
      msgId,
      email,
    },
  })
}

export const fetchNotificationCount = () => async (dispatch) => {
  const jwt = localStorage.getItem('id_token')
  const res = await request.get('/core/v0/notifications/count', {
    headers: {
      Authorization: 'Bearer ' + jwt,
    },
  })
  dispatch({
    type: FETCH_NOTIFICATION_COUNT,
    payload: res.data,
  })
}

export const clearNotifications = () => (dispatch, getState) => {
  const email = getState().login.email
  dispatch({
    type: CLEAR_NOTIFICATIONS,
    payload: {
      email,
      time: Date.now(),
    },
  })
}

export const hideNewNotification = (id) => ({
  type: HIDE_NEW_NOTIFICATION,
  id,
})

export const fetchMessages =
  (page = 0) =>
  async (dispatch) => {
    const jwt = localStorage.getItem('id_token')
    try {
      dispatch({
        type: 'FETCH_NOTIFICATION_START',
        payload: page,
      })
      axios
        .get(urlBase + '/notifications', {
          headers: {
            Authorization: 'Bearer ' + jwt,
          },
          params: {
            page,
          },
        })
        .then((res) =>
          dispatch({
            type: 'FETCH_NOTIFICATION_SUCCESS',
            payload: res.data,
          })
        )
    } catch (err) {
      console.error(err)
      dispatch({
        type: 'FETCH_NOTIFICATION_FAILURE',
        payload: err,
      })
    }
  }

export const feedbackMessage = (params, input) => async (dispatch) => {
  try {
    const jwt = localStorage.getItem('id_token')
    dispatch({
      type: 'NOTIFICATION_FEEDBACK_START',
      payload: { id: input.id },
    })
    axios
      .post('https://backend.phygitall.com/v0/notifications/app/confirmhelp', params, {
        headers: {
          Authorization: 'Bearer ' + jwt,
        },
      })
      .then((res) => dispatch(mutateNotification({ input })))
  } catch (err) {
    console.error(err)
    dispatch({
      type: 'NOTIFICATION_FEEDBACK_ERROR',
      payload: err,
    })
  }
}

export const broadcastMessage = (params) => async (dispatch) => {
  try {
    const jwt = localStorage.getItem('id_token')
    dispatch({
      type: 'NOTIFICATION_BROADCAST_START',
      payload: params,
    })
    axios
      .post(urlBase + `/emergency/evacuation/trigger`, params, {
        headers: {
          Authorization: 'Bearer ' + jwt,
        },
      })
      .then((res) =>
        dispatch({
          type: 'NOTIFICATION_BROADCAST_SUCCESS',
          payload: res?.data,
        })
      )
  } catch (err) {
    console.error(err)
    dispatch({
      type: 'NOTIFICATION_BROADCAST_ERROR',
      payload: err,
    })
  }
}

export const changeCurrentPage = (page) => ({
  type: 'CHANGE_NOTIFICATION_PAGE',
  payload: page,
})

export const fetchNotifications = (nextToken) => async (dispatch, getState) => {
  const tenant = getState().login.empresa
  const nextToken = getState().notification.nextToken
  const initialFetch = getState().notification.initialFetch
  if (!nextToken && !initialFetch) return
  try {
    dispatch({ type: 'FETCH_NOTIFICATIONS_START', tenant })
    const response = await API.graphql({
      query: listNotifications,
      variables: { tenant, limit: 10, nextToken, sortDirection: 'DESC' },
    })
    const payload = response.data.listNotifications
    dispatch({
      type: 'FETCH_NOTIFICATION_SUCCESS',
      payload,
    })
  } catch (err) {
    console.error('error fetching notifications', err)
  }
}

export const subscribeNotificationChange = (tenant, login) => (dispatch) => {
  return API.graphql({
    query: onChangeNotification,
    variables: {
      tenant,
    },
  }).subscribe({
    next: ({ provider, value }) => {
      const payload = value?.data?.onChangeNotification
      dispatch({ type: 'NEW_NOTIFICATION', payload, login })
    },
    error: (error) => console.warn('error', error),
  })
}

export const mutateNotification =
  ({ input }) =>
  async (dispatch) => {
    dispatch({ type: 'MUTATE_NOTIFICATION_START', input })
    try {
      var response = await API.graphql({
        query: updateNotification,
        variables: {
          input,
        },
      })
    } catch (err) {
      var error = err
      console.error('error:', err)
    }
    if (!error) dispatch({ type: 'MUTATE_NOTIFICATION_SUCCESS', payload: response?.data?.updateNotification })
  }

export const stopEmergency = () => ({ type: 'EMERGENCY_STOP' })

export const setEmergencyBounds = () => ({ type: 'SET_EMERGENCY_BOUNDS' })
